import { Record } from 'immutable'

export const PublicProTrackRecord = Record({
  id: null,
  name: null,
  createdAt: null,
  updatedAt: null,
  organizationId: null,
  organizationName: 'global',
})

export default class PublicProTrack extends PublicProTrackRecord {}
